<template>
   <div>
     <div class="search_unit">
       <div style='display:inline-block;'>
          <el-date-picker
          v-model="yearmonth"
          type="month"
          placeholder="选择月"
          value-format="yyyy-MM"
          >
          </el-date-picker>
        </div>
        <div style='display:inline-block;'>
          <el-input placeholder="ID/会员名/手机号码" v-model="keywords" class="input-with-select" @change='getList()'>
                    <el-select v-model="ispay" slot="prepend" placeholder="兑换状态" @change="resetCondition()">
                      <el-option label="未兑换"   value="0"></el-option>
                      <el-option label="已兑换" value="1"></el-option>
                    </el-select>
                    <el-button slot="append" icon="el-icon-search" @click='getList()'></el-button>
          </el-input>
        </div>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        prop="yearmonth"
        label="汇总年月">
      </el-table-column>
      <el-table-column
        prop="username"
        label="奖励人"
        >
      </el-table-column>
      <el-table-column
        prop="promotepoints"
        label="扶持">
      </el-table-column>
      <el-table-column
        prop="pkjpoints"
        label="平跨级">
      </el-table-column>
      <el-table-column
       
        label="业绩">
        <template slot-scope="scope">
           {{ scope.row.grouppoints }}<i class="el-icon-warning" v-if="scope.row.grouppoints>0" @click="getDetail(scope.row.userid)"></i>

        </template>
      </el-table-column>
      <el-table-column
      prop="cjpoints"
      label="差价">
    </el-table-column>
    <el-table-column
      prop="fhpoints"
      label="发货">
    </el-table-column>
    <el-table-column
      prop="yypoints"
      label="邀约">
    </el-table-column>
    <el-table-column
    prop="stpoints"
    label="实体">
    </el-table-column>
      <el-table-column
        prop="totalpoints"
        label="总积分">
      </el-table-column>
      <el-table-column
      label="有效积分">
      <template slot-scope="scope">
        <el-tag type="success" size="small">{{(scope.row.totalpoints*0.99).toFixed(2)}}</el-tag>
      </template>
    </el-table-column>
      <el-table-column
      label="兑换状态">
      <template slot-scope="scope"> 
        <el-tag type="success" v-if="scope.row.ispay==1">已兑换</el-tag>  <el-tag type="info" v-else-if="scope.row.ispay==0">未兑换</el-tag> 
      </template>
      </el-table-column>
      <el-table-column
      label="打款状态">
      <template slot-scope="scope"> 
        <div>
            <el-tag type="success" v-if="scope.row.status==2">打款成功</el-tag>
            <el-tag type="primary" v-else-if="scope.row.status==1">打款中</el-tag> 
            <el-tag type="danger"  v-else-if="scope.row.status==99">打款失败</el-tag> 
            <el-tag type="info"  v-else>未打款</el-tag>
        </div>
        <div v-if="scope.row.status==99">
             <span class="red">({{scope.row.paymsg}})</span>
        </div>
      </template>
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope"> 
          <!---<el-button type="primary" @click="goPay(scope.row.userid)" v-if="scope.row.status==0||scope.row.status==99">打款</el-button>-->
          <el-button type="info" @click="goPay(scope.row.userid)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
      <div class='page-number'>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="pageinfo.total"
          :page-size="pageinfo.pagesize"
          :current-page.sync="pageinfo.pageindex"
          @current-change='getList'
          >
        </el-pagination>
      </div>
      <el-dialog title="积分打款审核" :visible.sync="dialogFormVisible">
       <el-card class="box-card">
        <div>
          <ul class='pay-detail'>
             <li>兑换会员：{{payinfo.username}}</li>
             <li>兑换姓名：{{payinfo.realname}}</li>
             <li>兑换月份：{{payinfo.yearmonth}}</li>
             <li v-if="payinfo.status==0">兑换积分：{{payinfo.total}}</li>
             <li class="spliter" v-if="payinfo.status==0">实付金额：{{payinfo.realmoney}}</li>
        
             <li>收款姓名：{{payinfo.realname}}</li>
             <li>银行账号：{{payinfo.bankcard}}</li>
             <li>支付宝：{{payinfo.alipay}}</li>
             <li class="spliter">打款状态：
                  <el-tag type="success" v-if="payinfo.status==2">打款成功</el-tag>
                  <el-tag type="primary" v-else-if="payinfo.status==1">打款中</el-tag>
                  <el-tag type="danger" v-else-if="payinfo.status==99">打款失败</el-tag>
                  <el-tag type="info" v-else>未打款</el-tag>
                  <span v-if="payinfo.status==99 && payinfo.paymsg!=''" class="red">({{payinfo.paymsg}})</span>
             </li>

             <li v-if="payinfo.status==0||payinfo.status==99">
                打款方式：
                <el-radio-group v-model="paytype">
                  <el-radio :label="1">银行卡</el-radio>
                  <el-radio :label="2">支付宝</el-radio>
                  <el-radio :label="3">线下</el-radio>
                </el-radio-group>
             </li>
             <li v-else>
                打款方式：{{payinfo.paytypename}}
             </li>

          </ul>  
        </div>
       </el-card>
       <div slot="footer" class="dialog-footer" v-if="payinfo.status==0||payinfo.status==99">
         <el-input placeholder="请输入收到的验证码" v-model="yzm">
           <template slot="prepend"><span @click="sendSms(88)">发送验证码</span></template>
         </el-input>
         <div class="mt10">
           <el-button @click="dialogFormVisible = false">取 消</el-button>
           <el-button type="primary" @click="doPayout(payinfo['id'])">确认提交</el-button>
         </div>
       </div>
     </el-dialog>

     <el-dialog title="业绩详情" :visible.sync="dialogYejiVisible">
      <el-table :data="yejidetail">
        <el-table-column property="ordertime" label="日期" width="150"></el-table-column>
        <el-table-column property="ordernum" label="订单号" width="250"></el-table-column>
        <el-table-column property="name" label="订货人"></el-table-column>
        <el-table-column property="realmoney" label="金额"></el-table-column>
      </el-table>
    </el-dialog>
   </div> 
</template>

<script>
export default {
  data(){
     return {
        tableData:[],
        yearmonth:'',
        ispay:'',
        keywords:'',
        pageinfo:{
          total:0,
          pagesize:10,
          pageindex:1
        },

        dialogFormVisible:false,
        payinfo:{},

        yzm:'',
        processing:false,
        paytype:1,

        dialogYejiVisible:false,
        yejidetail:[]
     }
  },
  created(){
     this.getList()
  },
  methods: {
      getList(){
          this.$post("/prize/getPrizeSum",{pageinfo:this.pageinfo,yearmonth:this.yearmonth,keywords:this.keywords,ispay:this.ispay}).then((data)=>{
               if(data.result.success){
                  this.tableData=data.result.info.prizesum
                  this.pageinfo=data.result.info.pageinfo 
                  this.yearmonth=data.result.info.yearmonth
               }else{
                  this.$message.error(data.result.info)
               }
          })
      },
      goPay(userid){
          this.$post("/payout/getPointsPayInfo",{userid:userid,yearmonth:this.yearmonth}).then((data)=>{
              if(data.result.success){
                  this.payinfo=data.result.info
                  this.dialogFormVisible=true
              }else{
                  this.$message.error(data.result.info)
              }
          })
      },
      getDetail(userid){
          this.$post("/prize/getYejiDetail",{userid:userid,yearmonth:this.yearmonth}).then((data)=>{
              if(data.result.success){
                  this.yejidetail=data.result.info
                  this.dialogYejiVisible=true
              }else{
                  this.$message.error(data.result.info)
              }
          })
      },
      doPayout(userid){
         if(this.processing){
           this.$message.error("请等待打款完成")
           return false
         }
         if(this.yzm==''){
           this.$message.error("验证码不能为空")
           return false
         }
         this.processing=true
         this.$post("/payout/doPointsPayout",{userid:userid,yearmonth:this.yearmonth,paytype:this.paytype,yzm:this.yzm}).then((data)=>{
              this.processing=false
              this.resetCondition()
              if(data.result.success){
                  this.$message.success(data.result.info)
              }else{
                  this.$message.error(data.result.info)
              }
              this.getList()
              setTimeout(()=>{this.dialogFormVisible=false},1000)
         }) 
      },
      sendSms(type){
        this.$post("/sms/getSmscode",{type:type}).then((data)=>{
               if(data.result.success){
                  this.$message.success(data.result.info)
               }else{
                  this.$message.error(data.result.info)
               }
          })
      },
      resetCondition(){
         this.pageinfo={
          total:0,
          pagesize:10,
          pageindex:1
        }
        this.yzm=''
        this.paytype=1
      }
  }
}
</script>

<style scoped lang="scss">
.pay-detail {font-size:14px;}
.pay-detail li{padding: 0.1rem;list-style-type:none;border-bottom: 1px dashed #ccc;}
.page-number{margin-top:20px;float:right;}
.search-unit{margin-top: 15px;}
.spliter{border-bottom: 2px solid #ccc!important;}
.mt10{margin-top:10px;}
.red{color:#f56c6c}
</style>
